import { render, staticRenderFns } from "./ExpertStatisticsIndex.vue?vue&type=template&id=0a549d58&scoped=true"
import script from "./ExpertStatisticsIndex.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsIndex.vue?vue&type=script&lang=js"
import style0 from "./ExpertStatisticsIndex.vue?vue&type=style&index=0&id=0a549d58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a549d58",
  null
  
)

export default component.exports